module.exports = __webpack_public_path__ + "static/media/slide-image-2-large-min-new.f0a7961b.jpg";